import { call } from 'redux-saga/effects';
import { BlacklistResource } from '../../core/resources/blacklist.resource';
import { blacklistNormalizer } from './blacklist.normalizer';

export function* getBlacklist() {
  const response = yield call(BlacklistResource.getBlacklist);

  return blacklistNormalizer(response);
}

export function* postBlacklist(receiverId: string) {
  return yield call(BlacklistResource.postBlacklist, receiverId);
}

export function* deleteBlacklist(receiverId: string) {
  return yield call(BlacklistResource.deleteBlacklist, receiverId);
}
